import { render, staticRenderFns } from "./brick_2.vue?vue&type=template&id=76ea1dc6&scoped=true&"
import script from "./brick_2.vue?vue&type=script&lang=js&"
export * from "./brick_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea1dc6",
  null
  
)

export default component.exports